angular.module('qkr').controller('PushNotificationController', function($scope, $filter, pushNotificationService, utils) {

    $scope.modes = [
        {label: "Users", name:"MANUAL"}
    ];

    $scope.merchantsWithUserMerchantInfo = [];
    $scope.merchants = [];
    $scope.partners = [];
    $scope.countries = [];

    $scope.form = {};
    $scope.enabledSend = false;
    $scope.loading = false;
    $scope.loadingConfig = false;
    $scope.finished = false;
    $scope.holder = {};
    $scope.holder.minDate = new Date();
    $scope.dateOptions = {
        showWeeks: false
    };
    $scope.expandOutletTable = false;
    $scope.expandNotificationTable = true;
    $scope.sorterNotification = 'startTime';
    $scope.reverseMerchant = false;
    $scope.reverseOutlet = false;
    $scope.reverseCity = false;
    $scope.reverseState = false;
    $scope.reversePostalCode = false;
    $scope.reverseNotification = true;



    var init = function () {
        $scope.loadingConfig = true
        pushNotificationService.getPushNotificationConfig().then(function(response){
            var data = response.data;
            $scope.maxNotifications = data.maxNotifications;

            $scope.countries = data.countries;
            $scope.historicalMarketingPushNotifications = data.historicalMarketingPushNotifications;
            $scope.form.mode = $scope.modes[0].name;
            $scope.serverError = data.oldHmpnMessage;
            $scope.modeUpdate();
            $scope.loadingConfig = false;
        });

        $scope.setArrow('name', $scope.reverseMerchant, 'merchant');
        $scope.setArrow('name', $scope.reverseOutlet, 'outlet');
        $scope.setArrow('name', $scope.reverseCity, 'city');
        $scope.setArrow('name', $scope.reverseState, 'state');
        $scope.setArrow('name', $scope.reversePostalCode, 'postalCode');
        $scope.setArrowNotification('startTime', $scope.reverseNotification);

    };

    var valid = function() {
        $scope.errors = null;
        var valid = true;
        var errors = {};

        if( utils.hasNoValue($scope.form.title) ){
            errors.title = "Title required";
            valid = false;
        }
        if( utils.hasNoValue($scope.form.message) ){
            errors.message = "Message required";
            valid = false;
        }
        if ($scope.behaviour('merchant') && utils.hasNoValue($scope.form.userMerchantInfoMerchant)) {
            errors.country = "Merchant required";
            valid = false;
        }
        if ($scope.behaviour('country') && utils.hasNoValue($scope.form.country)) {
            errors.country = "Country required";
            valid = false;
        }
        if ($scope.behaviour('userEmails') && utils.hasNoValue($scope.userEmailsString)) {
            errors.userEmails = "At least one user email required";
            valid = false;
        }
        if ($scope.behaviour('excludeUser') && utils.hasNoValue($scope.form.ignoreUserThatHasNotLoggedInSince)) {
            errors.excludeUser = "A login date is required (Qkr launched in 2011 btw)";
            valid = false;
        }
        if ($scope.behaviour('excludeTrans') && !$scope.behaviour('excludeTransDisabled') && utils.hasNoValue($scope.form.ignoreUserThatHasNotTransactedSince)) {
            errors.country = "A transaction date is required (Qkr launched in 2011 btw)";
            valid = false;
        }
        if ($scope.behaviour('maxNotifications') && (utils.hasNoValue($scope.form.maxNotificationsSend) || $scope.form.maxNotificationsSend > $scope.maxNotifications)) {
            errors.maxNotifications = "Notification required or max has to be below " + $scope.maxNotifications;
            valid = false;
        }
        if ($scope.behaviour('categories') && utils.hasNoValue($scope.form.category)) {
            errors.categories = "Category required";
            valid = false;
        }
        if($scope.form.category == 'MERCHANT' && utils.hasNoValue($scope.form.categoryMerchantId) ){
            errors.categories = "Valid merchant required";
            valid = false;
        }
        if($scope.form.category == 'OUTLET' && utils.hasNoValue($scope.form.categoryOutletId) ){
            errors.categories = "Valid outlet required";
            valid = false;
        }
        if($scope.form.category == 'REWARD' && utils.hasNoValue($scope.form.categoryRewardId) ){
            errors.categories = "Scan Id Required";
            valid = false;
        }
        $scope.errors = errors;
        return valid;
    };

    $scope.sendPushNotification = function(checkUserCount) {
        $scope.serverError = null;
        if (!valid()) {
            return;
        }

        var confirmMessage = generateConfirmMessage();
        var confirm = window.confirm(confirmMessage);

        if(confirm == false){
            return;
        }

        setUpResultsArea(true);

        $scope.form.checkUserCount = checkUserCount;

        if($scope.behaviour('testRun')) {
            $scope.form.sendNotification = !$scope.testRun;
        }
        if($scope.behaviour('excludeNotification')) {
            $scope.form.excludeNotificationsId = [];
            angular.forEach($scope.historicalMarketingPushNotifications, function (hmpn) {
                if (hmpn.exclude) {
                    $scope.form.excludeNotificationsId.push(hmpn.id);
                }
            });
        }

        if($scope.behaviour('includeOutletTrans')) {
            var includeMerchantLocsId = [];
            angular.forEach($scope.merchants, function (merchant) {
                if (merchant.include) {
                    includeMerchantLocsId = includeMerchantLocsId.concat(merchant.ids);
                }
            });

            angular.forEach($scope.cities, function (city) {
                if (city.include) {
                    includeMerchantLocsId = includeMerchantLocsId.concat(city.ids);
                }
            });

            angular.forEach($scope.states, function (state) {
                if (state.include) {
                    includeMerchantLocsId = includeMerchantLocsId.concat(state.ids);
                }
            });

            angular.forEach($scope.postalCodes, function (postalCode) {
                if (postalCode.include) {
                    includeMerchantLocsId = includeMerchantLocsId.concat(postalCode.ids);
                }
            });

            angular.forEach($scope.outlets, function (outlet) {
                if (outlet.include) {
                    includeMerchantLocsId = includeMerchantLocsId.concat(outlet.ids);
                }
            });
            //Set enforces uniqueness
            $scope.form.includeMerchantLocsId = Array.from(new Set(includeMerchantLocsId));
        }
        if($scope.behaviour('userEmails')) {
            var emails = $scope.userEmailsString.split(',');
            $scope.form.userEmails = [];
            angular.forEach(emails, function (email) {
                $scope.form.userEmails.push(email.trim());
            });
        }

        var form = angular.copy($scope.form);
        if($scope.form.checkUserCount){
            form.sendNotification = false;
        }

        pushNotificationService.sendPushNotification(form).then(function(response) {
            finishUpResultsArea();
            var data = response.data;
            $scope.report.userCount = data.userCount;
        }, function(response) {
            finishUpResultsArea();
            if(response.data.exception) {
                $scope.serverError = response.data.exception;
            }
        });
    };

    $scope.killPushNotifications = function(){
        setUpResultsArea(false);
        pushNotificationService.killPushNotifications().then(function(response) {
            finishUpResultsArea();
            $scope.report.messageUserCounts = response.data.messageUserCounts;
        }, function(response) {
            finishUpResultsArea();
            if(response.data.exception) {
                $scope.serverError = response.data.exception;
            }
        });
    };

    var setUpResultsArea = function(sendCountMode){
        $scope.sendCountMode = sendCountMode;
        $scope.enabledSend = false;
        $scope.loading = true;
        $scope.finished = false;
        $scope.serverError = "";
        $scope.report = {};
    };

    var finishUpResultsArea = function(){
        $scope.loading = false;
        $scope.finished = true;
    };

    $scope.modeUpdate = function() {
        $scope.form.userMerchantInfoMerchant = $scope.behaviour('merchant')? $scope.merchantsWithUserMerchantInfo[0].id: "";
        $scope.form.country = $scope.behaviour('country')? "Australia": null;
        $scope.form.country = $scope.behaviour('countryAll')? "All": $scope.form.country;
        $scope.form.userEmails = $scope.behaviour('userEmails')? "": null;
        $scope.userEmailsString = $scope.behaviour('userEmails')? "": null;
        $scope.form.ignoreUserThatHasNotLoggedInSince = $scope.behaviour('excludeUser')? new Date(new Date().setDate(new Date().getDate()-180)): null;
        $scope.form.ignoreUserThatHasNotTransactedSince = $scope.behaviour('excludeTrans')? new Date(new Date().setDate(new Date().getDate()-180)): null;
        $scope.form.userCreatedAfter = $scope.behaviour('includeCreated')? null: null;
        $scope.form.maxNotificationsSend = $scope.behaviour('maxNotifications')? $scope.maxNotifications: null;
        $scope.form.noTransUsersOnly = $scope.behaviour('onlyNoTrans')? false: false;
        $scope.testRun = $scope.behaviour('testRun')? false: null;
        $scope.form.sendNotification = $scope.behaviour('testRun')? true: null;
        $scope.form.category = $scope.behaviour('categories')? "OTHER" : null;

        $scope.form.title = "Announcement";
        $scope.form.message = "";

        if( $scope.behaviour('excludeNotification')) {
            $scope.updateExcludeNotification($scope.expandNotificationTable);
        } else {
            $scope.updateExcludeNotification(false);
        }

        if( $scope.behaviour('includeOutletTrans') ) {
            $scope.updateIncludeOutletTrans($scope.expandOutletTable);
        }else{
            $scope.updateIncludeOutletTrans(false);
        }

        $scope.form.category = "OTHER";
        $scope.categoryUpdate();
        $scope.countryUpdate();
    };

    $scope.categoryUpdate = function(){
        $scope.details = "";
        $scope.detailIdNameExtras = [];
        $scope.form.categoryMerchantId = "";
        $scope.form.categoryOutletId = "";
        $scope.form.categoryRewardId = "";
    };

    $scope.countryUpdate = function(){
        $scope.loadingConfigOutlet = true;
        pushNotificationService.getPushNotificationOutletConfig($scope.form.country).then(function(response) {
            var data = response.data;

            $scope.merchants = data.merchants;
            $scope.merchantsWithUserMerchantInfo = data.merchantsWithUserMerchantInfo;
            $scope.cities = data.cities;
            $scope.states = data.states;
            $scope.postalCodes = data.postalCodes;
            $scope.outlets = data.outlets;
            $scope.loadingConfigOutlet = false;
        })

    };

    $scope.updateExcludeNotification = function(expandNotificationTable){
        if(!expandNotificationTable){
            $scope.form.excludeNotificationsId = [];
            angular.forEach($scope.historicalMarketingPushNotifications, function (historicalMarketingPushNotification) {
                historicalMarketingPushNotification.exclude = false;
            })
        }
    };

    $scope.updateIncludeOutletTrans = function(expandOutletTable){
        if(!expandOutletTable) {
            $scope.form.includeMerchantLocsId = [];
            angular.forEach($scope.merchants, function (merchant) {
                merchant.include = false;
            });
            angular.forEach($scope.cities, function (city) {
                city.include = false;
            });
            angular.forEach($scope.states, function (state) {
                state.include = false;
            });
            angular.forEach($scope.postalCodes, function (postalCode) {
                postalCode.include = false;
            });
            angular.forEach($scope.outlets, function (outlet) {
                outlet.include = false;
            })

        }
    };

    $scope.setArrow = function (active, reverse, tableName) {

        switch(tableName) {
            case "merchant":
                $scope.merchantNameArrow = "fa fa-sort";
                $scope.merchantIncludeArrow = "fa fa-sort";

                switch (active) {
                    case ('name') :
                        if (reverse) {
                            $scope.merchantNameArrow = "fa fa-sort-up";
                        } else {
                            $scope.merchantNameArrow = "fa fa-sort-down";
                        }
                        break;
                    case ('include') :
                        if (reverse) {
                            $scope.merchantIncludeArrow = "fa fa-sort-up";
                        } else {
                            $scope.merchantIncludeArrow = "fa fa-sort-down";
                        }
                        break;
                }
                break;

            case "outlet":
                $scope.outletNameArrow = "fa fa-sort";
                $scope.outletIncludeArrow = "fa fa-sort";

                switch (active) {
                    case ('name') :
                        if (reverse) {
                            $scope.outletNameArrow = "fa fa-sort-up";
                        } else {
                            $scope.outletNameArrow = "fa fa-sort-down";
                        }
                        break;
                    case ('include') :
                        if (reverse) {
                            $scope.outletIncludeArrow = "fa fa-sort-up";
                        } else {
                            $scope.outletIncludeArrow = "fa fa-sort-down";
                        }
                        break;
                }
                break;

            case "city":
                $scope.cityNameArrow = "fa fa-sort";
                $scope.cityIncludeArrow = "fa fa-sort";

                switch (active) {
                    case ('name') :
                        if (reverse) {
                            $scope.cityNameArrow = "fa fa-sort-up";
                        } else {
                            $scope.cityNameArrow = "fa fa-sort-down";
                        }
                        break;
                    case ('include') :
                        if (reverse) {
                            $scope.cityIncludeArrow = "fa fa-sort-up";
                        } else {
                            $scope.cityIncludeArrow = "fa fa-sort-down";
                        }
                        break;
                }
                break;

            case "state":
                $scope.stateNameArrow = "fa fa-sort";
                $scope.stateIncludeArrow = "fa fa-sort";

                switch (active) {
                    case ('name') :
                        if (reverse) {
                            $scope.stateNameArrow = "fa fa-sort-up";
                        } else {
                            $scope.stateNameArrow = "fa fa-sort-down";
                        }
                        break;
                    case ('include') :
                        if (reverse) {
                            $scope.stateIncludeArrow = "fa fa-sort-up";
                        } else {
                            $scope.stateIncludeArrow = "fa fa-sort-down";
                        }
                        break;
                }
                break;

            case "postalCode":
                $scope.postalCodeNameArrow = "fa fa-sort";
                $scope.postalCodeIncludeArrow = "fa fa-sort";

                switch (active) {
                    case ('name') :
                        if (reverse) {
                            $scope.postalCodeNameArrow = "fa fa-sort-up";
                        } else {
                            $scope.postalCodeNameArrow = "fa fa-sort-down";
                        }
                        break;
                    case ('include') :
                        if (reverse) {
                            $scope.postalCodeIncludeArrow = "fa fa-sort-up";
                        } else {
                            $scope.postalCodeIncludeArrow = "fa fa-sort-down";
                        }
                        break;
                }
                break;

        }



    };


    $scope.setArrowNotification = function (active, reverse) {

        $scope.notificationTypeArrow = "fa fa-sort";
        $scope.notificationMessageArrow = "fa fa-sort";
        $scope.notificationStartTimeArrow = "fa fa-sort";
        $scope.notificationUserCountArrow = "fa fa-sort";
        $scope.notificationExcludeArrow = "fa fa-sort";

        switch (active) {
            case ('type') :
                if (reverse) {
                    $scope.notificationTypeArrow = "fa fa-sort-up";
                } else {
                    $scope.notificationTypeArrow = "fa fa-sort-down";
                }
                break;
            case ('message') :
                if (reverse) {
                    $scope.notificationMessageArrow = "fa fa-sort-up";
                } else {
                    $scope.notificationMessageArrow = "fa fa-sort-down";
                }
                break;
            case ('startTime') :
                if (reverse) {
                    $scope.notificationStartTimeArrow = "fa fa-sort-up";
                } else {
                    $scope.notificationStartTimeArrow = "fa fa-sort-down";
                }
                break;
            case ('userCount') :
                if (reverse) {
                    $scope.notificationUserCountArrow = "fa fa-sort-up";
                } else {
                    $scope.notificationUserCountArrow = "fa fa-sort-down";
                }
                break;
            case ('exclude') :
                if (reverse) {
                    $scope.notificationExcludeArrow = "fa fa-sort-up";
                } else {
                    $scope.notificationExcludeArrow = "fa fa-sort-down";
                }
                break;
        }
    };

    $scope.checkCategory = function(detail, category){
        $scope.checkError = "";
        $scope.detailIdNameExtras = [];

        pushNotificationService.checkDetail(detail, category).then(function(response) {
            var data = response.data;
            $scope.detailIdNameExtras = data.detailIdNameExtras;
        }, function(response) {
            $scope.checkError = response.data.exception;
        });
    };


    $scope.behaviour = function(name){
        switch(name){
            case ('merchant'):
            case ('countryAll'):
                return $scope.form.mode == "MERCHANT";
            case ('userEmails'):
                return  $scope.form.mode == "MANUAL";
            case ('country'):
            case ('excludeUser'):
            case ('excludeTrans'):
            case ('includeCreated'):
            case ('maxNotifications'):
            case ('onlyNoTrans'):
            case ('excludeNotification'):
            case ('includeOutletTrans'):
                return ($scope.form.mode == "MASTERPASS" || $scope.form.mode == "MERCHANT" || $scope.form.mode == "ALL");
            case ('testRun'):
            case ('updateTables'):
            case ('categories'):
                return ($scope.form.mode == "MASTERPASS" || $scope.form.mode == "MERCHANT" || $scope.form.mode == "ALL" || $scope.form.mode == "MANUAL");
            //SPECIAL TRANS STUFF
            case ('includeOutletTransDisabled'):
            case ('excludeTransDisabled'):
                return $scope.form.noTransUsersOnly;
            default:
                return false;
        }
    };


    var generateConfirmMessage = function(){
         return  "Push Notifications will be sent with the following criteria \n" +
                 "ACTUALLY SEND NOTIFICATIONS (NOT TEST): \n" +
                 "Mode: " + $scope.form.mode + "\n" +
                 "Country of user: " + $scope.form.country + "\n" +
                 "User has last logged in after: " + $filter('date')($scope.form.ignoreUserThatHasNotLoggedInSince, 'medium') + "\n" +
                 "Users most recent purchase is after: " + $filter('date')($scope.form.ignoreUserThatHasNotTransactedSince, 'medium') + "\n" +
                 "Maximum amount of notifications sent: " + $scope.form.maxNotificationsSend + "\n" +
                 "Only target users who've never made a purchase: " + $scope.form.noTransUsersOnly + "\n" +
                 "Users account was created after: " +
                 ($scope.form.userCreatedAfter ? $filter('date')($scope.form.userCreatedAfter, 'medium'): "n/a") + "\n" +
                 "Target users who've made a purchase at (merchant): " + generateIncludedList($scope.merchants) + "\n" +
                 "Target users who've made a purchase at (outlet): " + generateIncludedList($scope.outlets) + "\n" +
                 "Target users who've made a purchase in (zipcode): " + generateIncludedList($scope.postalCodes) + " \n" +
                 "Target users who've made a purchase at (state): " + generateIncludedList($scope.states) + "\n" +
                 "Target users who've made a purchase at (city): " + generateIncludedList($scope.cities) + "\n" +
                 "Exclude users who received  previous notifications: " + generatePushNotificationsList($scope.historicalMarketingPushNotifications)  + " \n \n" +
                 "If any of this appears incorrect: DO NOT CLICK CONFIRM \n";
    };

    var generateIncludedList = function(locations){
        var locationNames = "";

        angular.forEach(locations, function(location){
            if(location.include){
                if(locationNames.length > 0){
                    locationNames+= ", " + location.name;
                }else{
                    locationNames = location.name;
                }
            }
        });

        if(locationNames.length > 0){
            return locationNames;
        }else{
            return "n/a";
        }
    };

    var generatePushNotificationsList = function(pushNotifications){
        var pushNotificationMessages = "";

        angular.forEach(pushNotifications, function(pushNotification){
            if(pushNotification.exclude){
                if(pushNotificationMessages.length > 0){
                    pushNotificationMessages+= ", " + pushNotification.message;
                }else{
                    pushNotificationMessages = pushNotification.message;
                }
            }
        });

        if(pushNotificationMessages.length > 0){
            return pushNotificationMessages;
        }else{
            return "n/a";
        }
    };

    init();

});



// WEBPACK FOOTER //
// ./src/controllers/mastercard/pushNotification.controller.js